/**
 * App
 * Rôle:
 * - Point d’entrée React Router pour la version 3D et la version Lite du portfolio.
 *
 * Responsabilités principales:
 * - Afficher le layout global (header, navigation, footer) et router vers `Home` et `Lite`.
 * - Proposer une bascule rapide vers la version légère pour les appareils sans WebGL.
 *
 * Évolutions attendues:
 * - Ajouter d’autres routes (blog, expérimentations) et un menu plus riche sur mobile.
 */
import { Navigate, Route, Routes, useLocation } from 'react-router-dom'
import type { Location } from 'react-router-dom'
import Lite from './routes/Lite'
import PortfolioDetail from '@/routes/PortfolioDetail'

export default function App() {
  const location = useLocation()
  const state = location.state as { backgroundLocation?: Location } | null

  return (
    <div className="min-h-dvh flex flex-col">
      <main className="flex-1">
        <Routes location={state?.backgroundLocation || location}>
          {/* <Route path="/" element={<Navigate to="/lite" replace />} /> */}
          <Route path="/" element={<Lite />} />
          <Route path="/lite" element={<Lite />} />
          <Route path="/portfolio/:kind/:slug" element={<PortfolioDetail mode="page" />} />
          <Route path="*" element={<Navigate to="/lite" replace />} />
        </Routes>
        {state?.backgroundLocation && (
          <Routes>
            <Route path="/portfolio/:kind/:slug" element={<PortfolioDetail mode="modal" />} />
          </Routes>
        )}
      </main>
      <footer className="border-t border-slate-800">
        <div className="mx-auto max-w-7xl px-4 py-6 text-xs text-slate-400">
          © {new Date().getFullYear()} Mourad Latoundji — Tous droits réservés
        </div>
      </footer>
    </div>
  )
}
